import request from './request';

const subscriberService = {
  getAll: (params) =>
    request.get('dashboard/admin/subscribers/all', { params }),
  export: () =>
    request.get('dashboard/admin/subscribers/export'),
  deleteOne: (id) =>
    request.delete(`dashboard/admin/subscribers/${id}`),
  deleteBulk: (ids) =>
    request.delete('dashboard/admin/subscribers/delete', { data: { ids } }),
};

export default subscriberService;
